import { render } from "./wokerDetail3.vue?vue&type=template&id=6c15322f&scoped=true"
import script from "./wokerDetail3.vue?vue&type=script&lang=js"
export * from "./wokerDetail3.vue?vue&type=script&lang=js"

import "./wokerDetail3.vue?vue&type=style&index=0&id=6c15322f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c15322f"]])

export default __exports__